import React from 'react';
import { Loader, SelectVirtualField, Helper } from 'Components';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import history from 'src/history';
import './NavDesktopClients.css';

const getLineCount = (val) => {
  if (val === undefined) return 0;
  if (val === null) return 0;

  const pattern = /[A-Z]/g;
  const uCaseChars = pattern.test(val) ? val.match(pattern).length : 0;
  const lCaseChars = val.length - uCaseChars;
  return Math.ceil((lCaseChars + (uCaseChars * 1.5)) / 30);
};

const ClientSelectField = ({
  clientNumber,
  setAppState,
  options,
  userInfo,
}) => (
  <SelectVirtualField
    deleteRemoves={false}
    backspaceRemoves={false}
    clearable={false}
    maxHeight={600}
    options={options}
    value={clientNumber}
    onChange={selected => setAppState({
    userInfo: {
      ...userInfo,
      ClientNumber: selected.value,
    },
  }, () => history.push('/'))}
    optionHeight={({ option }) => {
    const nodes = option.label.split('\n');
    const lineCounts = [
      getLineCount(nodes[0]),
      getLineCount(nodes[1]),
      getLineCount(nodes[2]),
    ];
    const lineCountsTotal = lineCounts.reduce((a, b) => a + b, 0);
    return (lineCountsTotal * 12) + 16;
  }}
  />
);

const OptimizedClientSelectField = React.memo(props => <ClientSelectField {...props} />);


const NavDesktopClients = ({
  clientNumber,
  setAppState,
  options,
  isLoading,
  userInfo,
}) => (
  <header className="nav__desktop__clients">
    <Helper text={i18n.t('tutorials:dashboardOverview.4')}>
      <h2>{i18n.t('nav:CLIENTS')}</h2>
    </Helper>

    <OptimizedClientSelectField
      clientNumber={clientNumber}
      setAppState={setAppState}
      options={options}
      userInfo={userInfo}
    />

    <hr />
    {isLoading && <Loader />}
  </header>
);

ClientSelectField.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  clientNumber: PropTypes.string,
  setAppState: PropTypes.func,
  userInfo: PropTypes.shape({
    ClientNumber: PropTypes.string,
  }),
};

NavDesktopClients.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  clientNumber: PropTypes.string,
  setAppState: PropTypes.func,
  isLoading: PropTypes.bool,
  userInfo: PropTypes.shape({
    ClientNumber: PropTypes.string,
  }),
};

export default NavDesktopClients;



// WEBPACK FOOTER //
// ./src/containers/Nav/NavDesktop/NavDesktopClients/NavDesktopClients.jsx